var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "spider-stats"
    },
    [
      _c("el-row", [
        _c(
          "div",
          { staticClass: "metric-list" },
          [
            _c("metric-card", {
              attrs: {
                label: "30-Day Tasks",
                icon: "fa fa-play",
                value: _vm.overviewStats.task_count,
                type: "danger"
              }
            }),
            _c("metric-card", {
              attrs: {
                label: "30-Day Results",
                icon: "fa fa-table",
                value: _vm.overviewStats.result_count,
                type: "primary"
              }
            }),
            _c("metric-card", {
              attrs: {
                label: "Success Rate",
                icon: "fa fa-check",
                value: _vm.getPercentStr(_vm.overviewStats.success_rate),
                type: "success"
              }
            }),
            _c("metric-card", {
              attrs: {
                label: "Avg Duration (sec)",
                icon: "fa fa-hourglass",
                value: _vm.getDecimal(_vm.overviewStats.avg_runtime_duration),
                type: "warning"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("el-card", { staticClass: "chart-wrapper" }, [
                _c("h4", [_vm._v(_vm._s(_vm.$t("Daily Tasks")))]),
                _c("div", { staticClass: "chart", attrs: { id: "task-line" } })
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("el-card", { staticClass: "chart-wrapper" }, [
                _c("h4", [_vm._v(_vm._s(_vm.$t("Daily Avg Duration (sec)")))]),
                _c("div", {
                  staticClass: "chart",
                  attrs: { id: "duration-line" }
                })
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }